import { dayjs } from "@thalamos/common";
import {
  MHA_STATUS_DASHBOARD_KEY,
  type OrganisationSupersetDashboard,
} from "@thalamos/aspire-common";

import { defaultMhaStatusFilters } from "../MhaStatusDashboard/defaultMhaStatusFilters.js";
import { type DashboardChooserItem } from "./DashboardChooser.js";
import mhaStatusTileImage from "~/assets/img/mha-status-dashboard-thumbnail.png";
import { routeFns } from "~/routePaths.js";

// Most-recently-viewed first; never-viewed last.
const viewedTime = (item: DashboardChooserItem): number =>
  item.lastViewedAt ? dayjs(item.lastViewedAt).valueOf() : -Infinity;

export const buildDashboardItems = (
  {
    showMha,
    section136Enabled,
    dashboards,
    mhaLastViewedAt,
  }: {
    showMha: boolean;
    section136Enabled: boolean;
    dashboards: OrganisationSupersetDashboard[];
    mhaLastViewedAt?: string | null;
  },
  navigate: (to: string) => void,
): DashboardChooserItem[] => {
  const items: DashboardChooserItem[] = [
    ...(showMha
      ? [
          {
            key: MHA_STATUS_DASHBOARD_KEY,
            label: "MHA Status Dashboard",
            lastViewedAt: mhaLastViewedAt,
            tileImage: mhaStatusTileImage,
            onSelect: () => {
              navigate(
                routeFns.mhaStatusDashboardPage(0, {
                  statuses: defaultMhaStatusFilters(section136Enabled),
                }),
              );
            },
          },
        ]
      : []),
    ...dashboards.map((dashboard) => ({
      key: dashboard.supersetDashboardId,
      label: dashboard.displayName,
      lastViewedAt: dashboard.lastViewedAt,
      tileImage: dashboard.thumbnail ?? undefined,
      onSelect: () => {
        navigate(routeFns.dashboardViewer(dashboard.supersetDashboardId));
      },
    })),
  ];

  // Stable sort keeps MHA-first / config order among never-viewed dashboards.
  return items.sort((a, b) => viewedTime(b) - viewedTime(a));
};
